const BackendErrorMessage = (error) => {    
    if (!error) {
        return 'Erro desconhecido';
    }

    // Caso seja uma resposta Axios com data
    if (error.response && error.response.data) {
        const data = error.response.data;
        
        // Se for no formato do seu erro 500 (com propriedade message no data)
        if (data.message && typeof data.message === 'string' && data.message.trim() !== '') {
            return data.message;
        }
        
        // Se for um array de erros (seu formato esperado original)
        if (Array.isArray(data) && data[0] && data[0].message && typeof data[0].message === 'string' && data[0].message.trim() !== '') {
            return data[0].message;
        }
        
        // Se o próprio data for uma string (mensagem direta)
        if (typeof data === 'string' && data.trim() !== '') {
            return data;
        }
    }

    if(error.status){
        switch(error.status) {
            case 500:
                return 'Erro interno no servidor';
            case 403:
                return 'Usuário não tem permissão para executar esta ação';
            case 404:
                return 'Recurso não encontrado';
        }
    }

    // Caso o erro tenha uma mensagem direta
    if (error.message && typeof error.message === 'string' && error.message.trim() !== '') {
        return error.message;
    }
    
    // Se nada mais for encontrado
    return 'Ocorreu um erro inesperado';
};

export default BackendErrorMessage;